import { parseApiDateTime } from './parseApiDateTime';

export const OUTSTANDING_FORM_STATUSES = ['PENDING', 'OPENED', 'IN_PROGRESS'];
export function requestStatus(request) {
    const status = request?.effective_status || request?.status || 'PENDING';
    const expiry = request?.expires_at;
    const parsed = expiry && (/^\d{4}-/.test(expiry) ? Date.parse(expiry) : parseApiDateTime(expiry)?.valueOf());
    return OUTSTANDING_FORM_STATUSES.includes(status) && parsed && parsed <= Date.now() ? 'EXPIRED' : status;
}
export function defaultDecision(row) {
    const requests = row.requests || [];
    if (!requests.length) return { action: 'create' };
    if (requests.length !== 1) return {};
    const request = requests[0];
    const decision = { request_id: request.id };
    if (OUTSTANDING_FORM_STATUSES.includes(requestStatus(request)) && request.sequence_eligible !== false && !request.context_changed) decision.action = 'reuse';
    return decision;
}
export function decisionReady(row, decision = {}) {
    if (decision.action === 'skip') return true;
    if (!(row.requests || []).length) return decision.action === 'create';
    const request = row.requests.find((r) => Number(r.id) === Number(decision.request_id));
    if (!request) return false;
    const status = requestStatus(request);
    if (decision.action === 'reuse') return OUTSTANDING_FORM_STATUSES.includes(status) && request.sequence_eligible !== false && (!request.context_changed || decision.acknowledge_context_difference === true);
    if (decision.action === 'replace') return status === 'EXPIRED' && request.sequence_eligible !== false;
    if (decision.action === 'replace_with_current') return request.sequence_eligible !== false && (OUTSTANDING_FORM_STATUSES.includes(status) || status === 'EXPIRED');
    if (decision.action === 'new_response') return ['SUBMITTED', 'REVOKED'].includes(status) && !row.requests.some((r) => r.id !== request.id && [...OUTSTANDING_FORM_STATUSES, 'EXPIRED'].includes(requestStatus(r)));
    return false;
}
export function hydrateDecisionLinks(forms, requests, actions = {}) {
    return forms.flatMap((form) => {
        const request = requests.find((r) => Number(r.form_id) === Number(form.id));
        if (!request) return [];
        return [{ form, accessToken: request.access_token || null, url: request.form_url || '', consentRequestId: request.id, expiresAt: request.expires_at || null, acknowledgeContextDifference: actions[String(form.id)]?.action === 'reuse' && actions[String(form.id)]?.acknowledge_context_difference === true }];
    });
}
export function deliveryActions(links) {
    return Object.fromEntries((links || []).filter((l) => l.consentRequestId).map((link) => [String(link.form.id), { action: 'reuse', request_id: link.consentRequestId, ...(link.acknowledgeContextDifference ? { acknowledge_context_difference: true } : {}) }]));
}

/** Stable retries for an intent, fresh keys after an explicit changed decision/context. */
export function intentKey(store, payload, createKey) {
    const intent = { ...payload };
    delete intent.idempotency_key;
    const fingerprint = JSON.stringify(intent);
    if (!store.has(fingerprint)) store.set(fingerprint, createKey());
    return store.get(fingerprint);
}
